import { useCallback } from "react";
import { useScanKit } from "../hooks/useScanKit";
import { useTranslation } from "react-i18next";

const MyScannerA = ({
  inputFieldName = 'identifier',
  wants12digitEAN = true,
  handleFieldValue,
  handleCloseScanner,
    }) => {

  const { t } = useTranslation();

  const handleScan = useCallback((code) => {
    console.log("RESULT:", code);
    handleFieldValue(inputFieldName, code);
    handleCloseScanner();
  }, [handleFieldValue, inputFieldName, handleCloseScanner]);

  // Free scanning engine (2026-07: replaced the licensed Scandit SDK;
  // 'useScanSix' + client/src/scandit/ were removed in that change):
  // native BarcodeDetector on Android Chrome, ZXing-WASM on iOS.
  const { containerRef, ready,
            } = useScanKit({
    wants12digitEAN,
    onScan: handleScan,
  });

  return (
    <div>
      {!ready && <p>Starting camera...</p>}

      {/* 👇 THIS is where the camera renders */}
      <div
        ref={containerRef}
        style={{
          width: "100%",
          height: "300px",
          position: "relative",
          overflow: "hidden", // Keep the video inside the box

          // background: "black",
          // Use dark grey instead of pure black to see if the element exists
          background: "#222",
        }}
      />
      <button onClick={handleCloseScanner}>
        {t('barcode.scanner.closeLabel')}
        {/* Close Scanner */}
      </button>
    </div>
  );
};

export default MyScannerA;
